<template>
  <v-container pa-0 fluid>
    <v-progress-circular 
        v-if="loading"
        :size="128"
        :width="12"
        color="primary"
        indeterminate
        class="custom-progress"
    ></v-progress-circular>

    <iframe 
      id="liveDesktop"
      @load="loading = false"
      src="https://livedesktop.alterdata.com.br/desktop/#/main?sysname=erp"
    ></iframe>

  </v-container>
</template>

<script>
import mixinMensagen from "@/mixin/mixin-mensagem";

export default {
  name: "Dashboard",
  mixins: [mixinMensagen],
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
  },
  methods: {
    ocultarSpinner() {
      this.loading = false;
    }    
  },
};
</script>

<style lang="scss" scoped>
h3 {
  color: $cor_primaria;
}

#liveDesktop {
  width: 100vw;
  height: 100vh;
  border: none;
}

.custom-progress {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
}

</style>
